var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs, _path26, _g2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBroom = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 132,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 132C102.451 132 132 102.451 132 66C132 29.5492 102.451 0 66 0C29.5492 0 0 29.5492 0 66C0 102.451 29.5492 132 66 132Z",
    fill: "#F4F6F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1439_189156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.0733 70.4245L63.3591 67.7488C62.779 67.1685 62.4531 66.3817 62.4531 65.5613C62.4531 64.7407 62.779 63.9539 63.3591 63.3738C63.9392 62.7936 64.7262 62.4678 65.5466 62.4678C66.367 62.4678 67.1538 62.7936 67.7341 63.3738L70.4676 66.0688",
    fill: "#74B0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0733 70.4245L63.3591 67.7488C62.779 67.1685 62.4531 66.3817 62.4531 65.5613C62.4531 64.7407 62.779 63.9539 63.3591 63.3738C63.9392 62.7936 64.7262 62.4678 65.5466 62.4678C66.367 62.4678 67.1538 62.7936 67.7341 63.3738L70.4676 66.0688",
    stroke: "#424855",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9111 72.5697C85.2929 72.8749 85.5511 73.3083 85.6373 73.7896C85.7236 74.2708 85.6321 74.767 85.3801 75.1859L82.0043 82.0214L75.1688 85.3972C74.7492 85.6516 74.2511 85.7444 73.7678 85.6581C73.2846 85.5716 72.8496 85.3123 72.5438 84.9282L67.2256 76.7539C66.1847 75.4526 65.6602 73.8132 65.7526 72.1493C65.845 70.4856 66.5476 68.9143 67.7261 67.7362C68.9044 66.5584 70.4755 65.8563 72.1389 65.7643C73.8023 65.6722 75.4411 66.1967 76.7421 67.2374L84.9111 72.5697Z",
    stroke: "#424855",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3561 63.3721L46.332 46.3096",
    stroke: "#424855",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.368 83.3221L73.8555 77.8096",
    stroke: "#424855",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8025 78.3783L77.793 73.8721",
    stroke: "#424855",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9474 28.8641C53.9474 29.4911 54.4188 30 54.9997 30C55.5812 30 56.0526 29.4911 56.0526 28.8641V27.0526H57.8639C58.491 27.0526 59 26.5811 59 26C59 25.4184 58.491 24.9474 57.8639 24.9474H56.0526V23.1365C56.0526 22.5089 55.5812 22 54.9997 22C54.4188 22 53.9474 22.5089 53.9474 23.1365V24.9474H52.1361C51.509 24.9474 51 25.4184 51 26C51 26.5811 51.509 27.0526 52.1361 27.0526H53.9474V28.8641Z",
    fill: "#CAD0D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9474 68.8641C23.9474 69.4911 24.4188 70 24.9997 70C25.5812 70 26.0526 69.4911 26.0526 68.8641V67.0526H27.8639C28.491 67.0526 29 66.5811 29 66C29 65.4184 28.491 64.9474 27.8639 64.9474H26.0526V63.1365C26.0526 62.5089 25.5812 62 24.9997 62C24.4188 62 23.9474 62.5089 23.9474 63.1365V64.9474H22.1361C21.509 64.9474 21 65.4184 21 66C21 66.5811 21.509 67.0526 22.1361 67.0526H23.9474V68.8641Z",
    fill: "#CAD0D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9474 100.864C56.9474 101.491 57.4188 102 57.9997 102C58.5812 102 59.0526 101.491 59.0526 100.864V99.0526H60.8639C61.491 99.0526 62 98.5811 62 98C62 97.4184 61.491 96.9474 60.8639 96.9474H59.0526V95.1365C59.0526 94.5089 58.5812 94 57.9997 94C57.4188 94 56.9474 94.5089 56.9474 95.1365V96.9474H55.1361C54.509 96.9474 54 97.4184 54 98C54 98.5811 54.509 99.0526 55.1361 99.0526H56.9474V100.864Z",
    fill: "#CAD0D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9474 114.864C82.9474 115.491 83.4188 116 83.9997 116C84.5812 116 85.0526 115.491 85.0526 114.864V113.053H86.8639C87.491 113.053 88 112.581 88 112C88 111.418 87.491 110.947 86.8639 110.947H85.0526V109.137C85.0526 108.509 84.5812 108 83.9997 108C83.4188 108 82.9474 108.509 82.9474 109.137V110.947H81.1361C80.509 110.947 80 111.418 80 112C80 112.581 80.509 113.053 81.1361 113.053H82.9474V114.864Z",
    fill: "#CAD0D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.947 57.8641C110.947 58.4911 111.419 59 112 59C112.581 59 113.053 58.4911 113.053 57.8641V56.0526H114.864C115.491 56.0526 116 55.5811 116 55C116 54.4184 115.491 53.9474 114.864 53.9474H113.053V52.1365C113.053 51.5089 112.581 51 112 51C111.419 51 110.947 51.5089 110.947 52.1365V53.9474H109.136C108.509 53.9474 108 54.4184 108 55C108 55.5811 108.509 56.0526 109.136 56.0526H110.947V57.8641Z",
    fill: "#CAD0D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5 15C76.3284 15 77 14.3284 77 13.5C77 12.6716 76.3284 12 75.5 12C74.6716 12 74 12.6716 74 13.5C74 14.3284 74.6716 15 75.5 15Z",
    fill: "#CAD0D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5 47C69.3284 47 70 46.3284 70 45.5C70 44.6716 69.3284 44 68.5 44C67.6716 44 67 44.6716 67 45.5C67 46.3284 67.6716 47 68.5 47Z",
    fill: "#CAD0D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 78C45.3284 78 46 77.3284 46 76.5C46 75.6716 45.3284 75 44.5 75C43.6716 75 43 75.6716 43 76.5C43 77.3284 43.6716 78 44.5 78Z",
    fill: "#CAD0D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 17C38.3284 17 39 16.3284 39 15.5C39 14.6716 38.3284 14 37.5 14C36.6716 14 36 14.6716 36 15.5C36 16.3284 36.6716 17 37.5 17Z",
    fill: "#CAD0D8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.5 33C107.328 33 108 32.3284 108 31.5C108 30.6716 107.328 30 106.5 30C105.672 30 105 30.6716 105 31.5C105 32.3284 105.672 33 106.5 33Z",
    fill: "#CAD0D8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5 86C94.3284 86 95 85.3284 95 84.5C95 83.6716 94.3284 83 93.5 83C92.6716 83 92 83.6716 92 84.5C92 85.3284 92.6716 86 93.5 86Z",
    fill: "#CAD0D8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.5 77C118.328 77 119 76.3284 119 75.5C119 74.6716 118.328 74 117.5 74C116.672 74 116 74.6716 116 75.5C116 76.3284 116.672 77 117.5 77Z",
    fill: "#CAD0D8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5 123C63.3284 123 64 122.328 64 121.5C64 120.672 63.3284 120 62.5 120C61.6716 120 61 120.672 61 121.5C61 122.328 61.6716 123 62.5 123Z",
    fill: "#CAD0D8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5 113C39.3284 113 40 112.328 40 111.5C40 110.672 39.3284 110 38.5 110C37.6716 110 37 110.672 37 111.5C37 112.328 37.6716 113 38.5 113Z",
    fill: "#CAD0D8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 41C24.8807 41 26 39.8807 26 38.5C26 37.1193 24.8807 36 23.5 36C22.1193 36 21 37.1193 21 38.5C21 39.8807 22.1193 41 23.5 41Z",
    fill: "#CAD0D8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 39.5C24.0523 39.5 24.5 39.0523 24.5 38.5C24.5 37.9477 24.0523 37.5 23.5 37.5C22.9477 37.5 22.5 37.9477 22.5 38.5C22.5 39.0523 22.9477 39.5 23.5 39.5Z",
    fill: "#F4F6F8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5 33C87.8807 33 89 31.8807 89 30.5C89 29.1193 87.8807 28 86.5 28C85.1193 28 84 29.1193 84 30.5C84 31.8807 85.1193 33 86.5 33Z",
    fill: "#CAD0D8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5 31.5C87.0523 31.5 87.5 31.0523 87.5 30.5C87.5 29.9477 87.0523 29.5 86.5 29.5C85.9477 29.5 85.5 29.9477 85.5 30.5C85.5 31.0523 85.9477 31.5 86.5 31.5Z",
    fill: "#F4F6F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5 57C87.8807 57 89 55.8807 89 54.5C89 53.1193 87.8807 52 86.5 52C85.1193 52 84 53.1193 84 54.5C84 55.8807 85.1193 57 86.5 57Z",
    fill: "#CAD0D8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5 55.5C87.0523 55.5 87.5 55.0523 87.5 54.5C87.5 53.9477 87.0523 53.5 86.5 53.5C85.9477 53.5 85.5 53.9477 85.5 54.5C85.5 55.0523 85.9477 55.5 86.5 55.5Z",
    fill: "#F4F6F8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 94C22.8807 94 24 92.8807 24 91.5C24 90.1193 22.8807 89 21.5 89C20.1193 89 19 90.1193 19 91.5C19 92.8807 20.1193 94 21.5 94Z",
    fill: "#CAD0D8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 92.5C22.0523 92.5 22.5 92.0523 22.5 91.5C22.5 90.9477 22.0523 90.5 21.5 90.5C20.9477 90.5 20.5 90.9477 20.5 91.5C20.5 92.0523 20.9477 92.5 21.5 92.5Z",
    fill: "#F4F6F8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.5 104C108.881 104 110 102.881 110 101.5C110 100.119 108.881 99 107.5 99C106.119 99 105 100.119 105 101.5C105 102.881 106.119 104 107.5 104Z",
    fill: "#CAD0D8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.5 102.5C108.052 102.5 108.5 102.052 108.5 101.5C108.5 100.948 108.052 100.5 107.5 100.5C106.948 100.5 106.5 100.948 106.5 101.5C106.5 102.052 106.948 102.5 107.5 102.5Z",
    fill: "#F4F6F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1439_189156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(45 45)"
  })))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 132,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 132",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 132C102.451 132 132 102.451 132 66C132 29.5492 102.451 0 66 0C29.5492 0 0 29.5492 0 66C0 102.451 29.5492 132 66 132Z",
    fill: "#F4F6F8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1439_189156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.0733 70.4245L63.3591 67.7488C62.779 67.1685 62.4531 66.3817 62.4531 65.5613C62.4531 64.7407 62.779 63.9539 63.3591 63.3738C63.9392 62.7936 64.7262 62.4678 65.5466 62.4678C66.367 62.4678 67.1538 62.7936 67.7341 63.3738L70.4676 66.0688",
    fill: "#74B0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0733 70.4245L63.3591 67.7488C62.779 67.1685 62.4531 66.3817 62.4531 65.5613C62.4531 64.7407 62.779 63.9539 63.3591 63.3738C63.9392 62.7936 64.7262 62.4678 65.5466 62.4678C66.367 62.4678 67.1538 62.7936 67.7341 63.3738L70.4676 66.0688",
    stroke: "#424855",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9111 72.5697C85.2929 72.8749 85.5511 73.3083 85.6373 73.7896C85.7236 74.2708 85.6321 74.767 85.3801 75.1859L82.0043 82.0214L75.1688 85.3972C74.7492 85.6516 74.2511 85.7444 73.7678 85.6581C73.2846 85.5716 72.8496 85.3123 72.5438 84.9282L67.2256 76.7539C66.1847 75.4526 65.6602 73.8132 65.7526 72.1493C65.845 70.4856 66.5476 68.9143 67.7261 67.7362C68.9044 66.5584 70.4755 65.8563 72.1389 65.7643C73.8023 65.6722 75.4411 66.1967 76.7421 67.2374L84.9111 72.5697Z",
    stroke: "#424855",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3561 63.3721L46.332 46.3096",
    stroke: "#424855",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.368 83.3221L73.8555 77.8096",
    stroke: "#424855",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8025 78.3783L77.793 73.8721",
    stroke: "#424855",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9474 28.8641C53.9474 29.4911 54.4188 30 54.9997 30C55.5812 30 56.0526 29.4911 56.0526 28.8641V27.0526H57.8639C58.491 27.0526 59 26.5811 59 26C59 25.4184 58.491 24.9474 57.8639 24.9474H56.0526V23.1365C56.0526 22.5089 55.5812 22 54.9997 22C54.4188 22 53.9474 22.5089 53.9474 23.1365V24.9474H52.1361C51.509 24.9474 51 25.4184 51 26C51 26.5811 51.509 27.0526 52.1361 27.0526H53.9474V28.8641Z",
    fill: "#CAD0D8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9474 68.8641C23.9474 69.4911 24.4188 70 24.9997 70C25.5812 70 26.0526 69.4911 26.0526 68.8641V67.0526H27.8639C28.491 67.0526 29 66.5811 29 66C29 65.4184 28.491 64.9474 27.8639 64.9474H26.0526V63.1365C26.0526 62.5089 25.5812 62 24.9997 62C24.4188 62 23.9474 62.5089 23.9474 63.1365V64.9474H22.1361C21.509 64.9474 21 65.4184 21 66C21 66.5811 21.509 67.0526 22.1361 67.0526H23.9474V68.8641Z",
    fill: "#CAD0D8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9474 100.864C56.9474 101.491 57.4188 102 57.9997 102C58.5812 102 59.0526 101.491 59.0526 100.864V99.0526H60.8639C61.491 99.0526 62 98.5811 62 98C62 97.4184 61.491 96.9474 60.8639 96.9474H59.0526V95.1365C59.0526 94.5089 58.5812 94 57.9997 94C57.4188 94 56.9474 94.5089 56.9474 95.1365V96.9474H55.1361C54.509 96.9474 54 97.4184 54 98C54 98.5811 54.509 99.0526 55.1361 99.0526H56.9474V100.864Z",
    fill: "#CAD0D8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9474 114.864C82.9474 115.491 83.4188 116 83.9997 116C84.5812 116 85.0526 115.491 85.0526 114.864V113.053H86.8639C87.491 113.053 88 112.581 88 112C88 111.418 87.491 110.947 86.8639 110.947H85.0526V109.137C85.0526 108.509 84.5812 108 83.9997 108C83.4188 108 82.9474 108.509 82.9474 109.137V110.947H81.1361C80.509 110.947 80 111.418 80 112C80 112.581 80.509 113.053 81.1361 113.053H82.9474V114.864Z",
    fill: "#CAD0D8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.947 57.8641C110.947 58.4911 111.419 59 112 59C112.581 59 113.053 58.4911 113.053 57.8641V56.0526H114.864C115.491 56.0526 116 55.5811 116 55C116 54.4184 115.491 53.9474 114.864 53.9474H113.053V52.1365C113.053 51.5089 112.581 51 112 51C111.419 51 110.947 51.5089 110.947 52.1365V53.9474H109.136C108.509 53.9474 108 54.4184 108 55C108 55.5811 108.509 56.0526 109.136 56.0526H110.947V57.8641Z",
    fill: "#CAD0D8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5 15C76.3284 15 77 14.3284 77 13.5C77 12.6716 76.3284 12 75.5 12C74.6716 12 74 12.6716 74 13.5C74 14.3284 74.6716 15 75.5 15Z",
    fill: "#CAD0D8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5 47C69.3284 47 70 46.3284 70 45.5C70 44.6716 69.3284 44 68.5 44C67.6716 44 67 44.6716 67 45.5C67 46.3284 67.6716 47 68.5 47Z",
    fill: "#CAD0D8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 78C45.3284 78 46 77.3284 46 76.5C46 75.6716 45.3284 75 44.5 75C43.6716 75 43 75.6716 43 76.5C43 77.3284 43.6716 78 44.5 78Z",
    fill: "#CAD0D8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 17C38.3284 17 39 16.3284 39 15.5C39 14.6716 38.3284 14 37.5 14C36.6716 14 36 14.6716 36 15.5C36 16.3284 36.6716 17 37.5 17Z",
    fill: "#CAD0D8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.5 33C107.328 33 108 32.3284 108 31.5C108 30.6716 107.328 30 106.5 30C105.672 30 105 30.6716 105 31.5C105 32.3284 105.672 33 106.5 33Z",
    fill: "#CAD0D8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5 86C94.3284 86 95 85.3284 95 84.5C95 83.6716 94.3284 83 93.5 83C92.6716 83 92 83.6716 92 84.5C92 85.3284 92.6716 86 93.5 86Z",
    fill: "#CAD0D8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.5 77C118.328 77 119 76.3284 119 75.5C119 74.6716 118.328 74 117.5 74C116.672 74 116 74.6716 116 75.5C116 76.3284 116.672 77 117.5 77Z",
    fill: "#CAD0D8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5 123C63.3284 123 64 122.328 64 121.5C64 120.672 63.3284 120 62.5 120C61.6716 120 61 120.672 61 121.5C61 122.328 61.6716 123 62.5 123Z",
    fill: "#CAD0D8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5 113C39.3284 113 40 112.328 40 111.5C40 110.672 39.3284 110 38.5 110C37.6716 110 37 110.672 37 111.5C37 112.328 37.6716 113 38.5 113Z",
    fill: "#CAD0D8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 41C24.8807 41 26 39.8807 26 38.5C26 37.1193 24.8807 36 23.5 36C22.1193 36 21 37.1193 21 38.5C21 39.8807 22.1193 41 23.5 41Z",
    fill: "#CAD0D8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 39.5C24.0523 39.5 24.5 39.0523 24.5 38.5C24.5 37.9477 24.0523 37.5 23.5 37.5C22.9477 37.5 22.5 37.9477 22.5 38.5C22.5 39.0523 22.9477 39.5 23.5 39.5Z",
    fill: "#F4F6F8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5 33C87.8807 33 89 31.8807 89 30.5C89 29.1193 87.8807 28 86.5 28C85.1193 28 84 29.1193 84 30.5C84 31.8807 85.1193 33 86.5 33Z",
    fill: "#CAD0D8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5 31.5C87.0523 31.5 87.5 31.0523 87.5 30.5C87.5 29.9477 87.0523 29.5 86.5 29.5C85.9477 29.5 85.5 29.9477 85.5 30.5C85.5 31.0523 85.9477 31.5 86.5 31.5Z",
    fill: "#F4F6F8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5 57C87.8807 57 89 55.8807 89 54.5C89 53.1193 87.8807 52 86.5 52C85.1193 52 84 53.1193 84 54.5C84 55.8807 85.1193 57 86.5 57Z",
    fill: "#CAD0D8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5 55.5C87.0523 55.5 87.5 55.0523 87.5 54.5C87.5 53.9477 87.0523 53.5 86.5 53.5C85.9477 53.5 85.5 53.9477 85.5 54.5C85.5 55.0523 85.9477 55.5 86.5 55.5Z",
    fill: "#F4F6F8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 94C22.8807 94 24 92.8807 24 91.5C24 90.1193 22.8807 89 21.5 89C20.1193 89 19 90.1193 19 91.5C19 92.8807 20.1193 94 21.5 94Z",
    fill: "#CAD0D8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 92.5C22.0523 92.5 22.5 92.0523 22.5 91.5C22.5 90.9477 22.0523 90.5 21.5 90.5C20.9477 90.5 20.5 90.9477 20.5 91.5C20.5 92.0523 20.9477 92.5 21.5 92.5Z",
    fill: "#F4F6F8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.5 104C108.881 104 110 102.881 110 101.5C110 100.119 108.881 99 107.5 99C106.119 99 105 100.119 105 101.5C105 102.881 106.119 104 107.5 104Z",
    fill: "#CAD0D8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.5 102.5C108.052 102.5 108.5 102.052 108.5 101.5C108.5 100.948 108.052 100.5 107.5 100.5C106.948 100.5 106.5 100.948 106.5 101.5C106.5 102.052 106.948 102.5 107.5 102.5Z",
    fill: "#F4F6F8"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1439_189156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(45 45)"
  })))));
});
export default SvgBroom;
export const raw = __webpack_public_path__ + "static/media/broom.a56dea4cfc5f090e97b120b76b3e6154.svg";